import React from 'react';
import {Avatar, Space} from 'antd';
import PropTypes from 'prop-types';
import {
  StyledUserDetailsEmail,
  StyledUserDetailsName
} from './StyledUserDetails';
import {textHelpers} from '../../utils/helpers';

const UserDetails = ({
  avatarProps,
  customAvatar = undefined,
  email = true,
  user,
  ...rest
}) => {

  const userEmail = user?.email || '';
  const label = user?.label || '';
  const name = user?.full_name || '';
  const src = user?.logo || undefined;
  const initials = textHelpers.getInitials(name || userEmail);

  return (
    <Space
      size='small'
      {...rest}
    >
      {customAvatar ? customAvatar : <Avatar {...avatarProps} src={src}>{initials}</Avatar>}
      <Space
        size={0}
        direction='vertical'
      >
        {label && <StyledUserDetailsName>{label}</StyledUserDetailsName>}
        {(name && !label) && <StyledUserDetailsName>{name}</StyledUserDetailsName>}
        {email && <StyledUserDetailsEmail>{userEmail}</StyledUserDetailsEmail>}
      </Space>
    </Space>
  );
}

UserDetails.propTypes = {
  customAvatar: PropTypes.any,
  email: PropTypes.bool,
  user: PropTypes.shape({
    email: PropTypes.string,
    label: PropTypes.string,
    full_name: PropTypes.string,
    logo: PropTypes.string,
  })
}

export default UserDetails;
